// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c93160d3","455":"d4974367","977":"15595802"}[chunkId] + ".chunk.js";
};